import { GlobalStyles } from '@mui/material';
import { css } from '@emotion/react';

// 1. Importe cada arquivo de fonte diretamente
import PoppinsLight from '@/assets/fonts/Poppins-Light.ttf';
import PoppinsRegular from '@/assets/fonts/Poppins-Regular.ttf';
import PoppinsMedium from '@/assets/fonts/Poppins-Medium.ttf';
import PoppinsSemiBold from '@/assets/fonts/Poppins-SemiBold.ttf';
import PoppinsBold from '@/assets/fonts/Poppins-Bold.ttf';

const GlobalStyle = () => (
  <GlobalStyles
    styles={css`
      /* Light (300) */
      @font-face {
        font-family: 'Poppins';
        src: url(${PoppinsLight}) format('truetype');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }

      /* Regular (400) */
      @font-face {
        font-family: 'Poppins';
        src: url(${PoppinsRegular}) format('truetype');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }

      /* Medium (500) */
      @font-face {
        font-family: 'Poppins';
        src: url(${PoppinsMedium}) format('truetype');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
      }

      /* SemiBold (600) */
      @font-face {
        font-family: 'Poppins';
        src: url(${PoppinsSemiBold}) format('truetype');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }

      /* Bold (700) */
      @font-face {
        font-family: 'Poppins';
        src: url(${PoppinsBold}) format('truetype');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
      }

      body {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Poppins', 'Inter', sans-serif;
      }
      * {
        box-sizing: border-box;
      }
      a {
        text-decoration: none;
        color: inherit;
      }
      button {
        /*
          Você pode remover a borda padrão com:
          border: none;
        */
        outline: none;
        box-shadow: none;
      }
    `}
  />
);

export default GlobalStyle;
